import AppointmentList from '@/views/Appointment/AppointmentList'
import AppointmentDetail from '@/views/Appointment/Detail/AppointmentDetail'
import AppointmentEdit from '@/views/Appointment/AppointmentEdit'
import AppointmentAdd from '@/views/Appointment/AppointmentAdd'

const appointment = [
  {
    path: 'appointments',
    name: 'AppointmentList',
    component: AppointmentList
  },
  {
    path: 'appointment/:id/detail',
    name: 'AppointmentDetail',
    component: AppointmentDetail
  },
  {
    path: 'appointment/:id',
    name: 'AppointmentEdit',
    component: AppointmentEdit
  },
  {
    path: 'appointment/add',
    name: 'AppointmentAdd',
    component: AppointmentAdd
  }
];

export default appointment;



// WEBPACK FOOTER //
// ./src/router/modules/appointment.js